import { AuthForm } from "@/components/auth-form";
import { SeoHead } from "@/components/seo-head";

export function LogInPage() {
  return (
    <>
      <SeoHead
        title="Log in"
        description="Log in to your TodoLLM account."
        canonical="https://todollm.com/log-in"
        noIndex
      />
      <AuthForm mode="signin" />
    </>
  );
}
